import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { gsap } from 'gsap';
import { useToast } from '../../contexts/ToastContext';
import ToastComponent from './Toast';

const ToastContainer: React.FC = () => {
  const { toasts } = useToast();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Create portal container if it doesn't exist
    let portalContainer = document.getElementById('toast-portal');
    if (!portalContainer) {
      portalContainer = document.createElement('div');
      portalContainer.id = 'toast-portal';
      portalContainer.className = 'toast-portal';
      document.body.appendChild(portalContainer);
    }
  }, []);

  useEffect(() => {
    if (containerRef.current && toasts.length > 0) {
      // Animate new toasts
      const toastElements = containerRef.current.querySelectorAll('.toast-item:last-child');
      toastElements.forEach(element => {
        gsap.fromTo(element, 
          { x: 100, opacity: 0, scale: 0.95 },
          { x: 0, opacity: 1, scale: 1, duration: 0.3, ease: 'power2.out' }
        );
      });
    }
  }, [toasts.length]);

  const portalContainer = document.getElementById('toast-portal');
  
  if (!portalContainer || toasts.length === 0) {
    return null;
  }

  return createPortal(
    <div 
      ref={containerRef}
      className="fixed top-4 right-4 z-50 space-y-3 max-w-sm w-full sm:max-w-md"
      role="region"
      aria-label="Notifications"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <ToastComponent key={toast.id} toast={toast} />
      ))}
    </div>,
    portalContainer
  );
};

export default ToastContainer;
